export default __webpack_public_path__ + "static/media/Gradient Logo Watermark.4abed0df.svg";